import { css } from 'aphrodite';
import { inject, observer } from 'mobx-react';
import { MastheadPortalId } from '../../../models/AdminModels';
import { ErrorMessagesViewModelKey, UserSessionViewModelKey } from '../../../models/AppState';
import { useFullscreenModal } from '../../../models/hooks/appStateHooks';
import { NavigationBreadcrumbsBar } from '../../../web/components/NavigationBreadcrumbsBar';
import { Portal } from '../../../web/components/Portal';
import { HangFireIcon } from '../../../web/components/svgs/icons/HangFireIcon';
import { ToolsCard } from '../../components/tools/ToolsCard';
import { styleSheet } from './styles';

function _DevTools() {
	const fullscreenModal = useFullscreenModal();
	const handleHangfireClick = () => {
		fullscreenModal.history.push('/devtools/hangfire');
	};
	return (
		<div>
			<Portal destination={MastheadPortalId}>
				<NavigationBreadcrumbsBar currentLocationName='DevTools' />
			</Portal>
			<div className={css(styleSheet.cards)}>
				<ToolsCard
					image={<HangFireIcon className={css(styleSheet.icon)} />}
					onClick={handleHangfireClick}
					title='Hangfire'
				>
					{['Generate job scheduler tokens']}
				</ToolsCard>
			</div>
		</div>
	);
}

export const DevTools = inject(UserSessionViewModelKey, ErrorMessagesViewModelKey)(observer(_DevTools));
